import { CSSProgressiveCaption01, CSSProgressiveCaption01Medium } from "@caisy/league";
import styled, { css } from "styled-components";

const CSSAlignedCenter = css`
  text-align: center;
`;

export const SRegisterFormRichText = styled.div`
  ${CSSProgressiveCaption01Medium};
  color: var(--text-04);
  width: 100%;

  ${({ alignCenter }) => alignCenter && CSSAlignedCenter}

  a {
    ${CSSProgressiveCaption01}
    color: var(--text-09);
  }

  ul {
    margin-left: 24px;
    list-style: unset;
  }

  li {
    display: flex;
    align-items: center;
    gap: 6px;
  }
`;
